export default window.M;